import { useCallback, useState } from "react";

type UseForceRenderReturnType = {
  forceRender: () => void;
};

const useForceRender = (): UseForceRenderReturnType => {
  const [, toggle] = useState(false);

  const forceRender = useCallback(() => {
    toggle((prev) => !prev);
  }, []);

  return {
    forceRender,
  };
};

export { useForceRender };
